import 'select2';
import 'select2/dist/css/select2';
import '../entrypoints/src/admin/jquery_plugins/dynamic_option_select2';
import BootstrapNavTabs from '../entrypoints/src/admin/components/bootstrap_nav_bars';
import LevelService from '../entrypoints/src/admin/services/level-service';

import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    'courseNameIdentification',
    'courseLevel',
    'classFormat',
    'whenIndividualFormat',
    'whenBatchFormat',
    'whenFormats',
    'flexibleSchedules',
    'whenFlexibleSchedules'
  ];

  initialize() {
    this.bindingSelect2(this.courseLevelTarget, LevelService, 'Nível/Módulo');
  }

  connect() {
    try {
      BootstrapNavTabs.mergeCustomFeatures(this.element.querySelector('.tr-nav'));
      document.addEventListener("turbo:frame-load", (ev) => {
        if (ev.target.getAttribute('id') == 'batch-frame-modal') {
          this.updateFrameWithUpdatedAttributes(ev.target.querySelectorAll('[data-controller="batch"]'));
        }
      });

      this.toggleFields();
      this.flexibleSchedulesTarget.addEventListener('change', (ev) => this.onChangeFlexibleSchedules() );
      this.dispatchEvent(this.flexibleSchedulesTarget, 'change');

      document.body.addEventListener('turbo:frame-load', (ev) => {
        if (ev.target.getAttribute('id') == 'service-batches')
          this.dispatchEvent(this.flexibleSchedulesTarget, 'change');
      });
    } catch (ex) {
      console.log('%cNenhuma turma para observar', 'background-color: darkblue; color: white; font-style: italic; border: 5px solid hotpink; font-size: 2em;');
    }
  }

  onChangeFlexibleSchedules() {
    this.element.querySelector('#frequency-values').classList.toggle('d-block', this.flexibleSchedulesTarget.checked || this.classFormatTarget.value === 'individual');
    this.whenFlexibleSchedulesTargets.forEach(($el) => $el.classList.toggle(($el.dataset.toggleClass || 'd-block'), this.flexibleSchedulesTarget.checked || this.classFormatTarget.value === 'individual'));
    this.updateFrameWithUpdatedAttributes(this.element.querySelectorAll('[data-controller="batch"]'));
  }

  updateBatchesFrame(mutationRecords) {
    if (!mutationRecords || mutationRecords.length <= 1)
      return;

    mutationRecords.forEach((mr) => {
      const element = mr.target;
      if (element.nodeName === 'TURBO-FRAME' && mr.addedNodes.length > 0)
        this.updateFrameWithUpdatedAttributes([this.element.querySelector('.batches .at-batches turbo-frame:last-child [data-controller="batch"]')]);
    });
  }

  updateFrameWithUpdatedAttributes(targets) {
    let attributes = [{ type: 'hidden', name: 'flexible_schedules', value: this.flexibleSchedulesTarget.checked }];
    targets.forEach(($el) => !!$el && ($el.dataset.attributes = JSON.stringify(attributes)));
  }

  dispatchEvent(target, event) {
    target.dispatchEvent(new Event(event));
  }

  bindingSelect2($selectElement, model, itemTypeName) {
    $($selectElement).select2()
    .dynamicOption({
      text: `+ Novo ${itemTypeName}`,
      modalTitle: `Novo ${itemTypeName}`,
      modalLabelName: `${itemTypeName}`,
      saveItem: async (name, id) => {
        let resources = itemTypeName == 'Nível/Módulo' ? { level: { name: name } } : { model_identification: { name: name, model: 'course' } };
        let modelIdentification = !id ? await model.create(resources) : await model.update(id, resources);
        return modelIdentification.id;
      },
      removeItem: async (id) => { return await model.destroy(id) },
    });
  }

  // stimulus-events
  toggleFields() {
    if (!this.classFormatTarget.value)
      return;

    this.whenIndividualFormatTargets.forEach(($el) => $el.classList.toggle(($el.dataset.toggleClass || 'd-block'), this.classFormatTarget.value === 'individual'));
    this.whenBatchFormatTargets.forEach(($el) => $el.classList.toggle(($el.dataset.toggleClass || 'd-block'), this.classFormatTarget.value === 'batch'));
    // data-formats lists every classes_format that shows the element (space separated).
    this.whenFormatsTargets.forEach(($el) => $el.classList.toggle(($el.dataset.toggleClass || 'd-block'), ($el.dataset.formats || '').split(' ').includes(this.classFormatTarget.value)));
    this.dispatchEvent(this.flexibleSchedulesTarget, 'change');
  }
}